import { action, observable, runInAction } from 'mobx'
import { message } from 'hljd'
import { hashHistory } from 'react-router'
import Api from '@api/xiu_yan/realnameAuthenticationApi'
import siYiApi from '@api/xiu_yan/siYiGroupApi'
import commonApi from '@api/common'
import { getMerchantInfo, isObj } from '@util'
import http from '@core/fetch'

class Store {
  indexStore

  flag
  f_realname
  f_certify
  f_certify_front
  f_certify_back
  f_company_license
  f_company_code
  f_company_name

  @observable time
  @observable fail_reason
  @observable failVisible = false
  @observable pending_status = 0
  infoId

  @action
  getCertifyInfo = async () => {
    let {
      data: {
        certify: {
          merchant_id,
          type,
          realname,
          certify,
          certify_front,
          certify_back,
          company_license,
          updated_at,
          created_at,
          fail_reason,
          pending_status,
          company_code,
          company_name
        }
      }
    } = await siYiApi.getGroupInfo()
    runInAction(() => {
      this.type = type || '2'
      this.infoId = merchant_id
      this.pending_status = pending_status
      if (type == 1) {
        this.p_params = {
          p_realname: realname,
          p_certify: certify,
          p_certify_front: certify_front,
          p_certify_back: certify_back
        }
      } else {
        this.c_params = {
          c_realname: realname,
          c_certify: certify,
          c_certify_front: certify_front,
          c_certify_back: certify_back,
          c_company_license: company_license,
          c_company_code: company_code,
          c_company_name: company_name
        }
      }

      if (created_at) {
        this.time = created_at
      } else {
        this.time = updated_at
      }

      if (pending_status == 2) {
        this.failVisible = true
        this.fail_reason = fail_reason
      }

      this.flag = type
      this.f_realname = realname
      this.f_certify = certify
      this.f_certify_front = certify_front
      this.f_certify_back = certify_back
      this.f_company_license = company_license
      this.f_company_code = company_code
      this.f_company_name = company_name
    })
  }

  @observable
  p_params = {
    p_realname: '',
    p_certify: '',
    p_certify_front: '',
    p_certify_back: ''
  }

  @observable
  c_params = {
    c_realname: '',
    c_certify: '',
    c_certify_front: '',
    c_certify_back: '',
    c_company_license: '',
    c_company_code: '',
    c_company_name: ''
  }

  getSafeImg = async url => {
    const { success, data } = await commonApi.getSafeImg({ url })
    if (success) {
      return data
    }
  }

  @action
  uploadCard = (params, is_safe) => async (file, link) => {
    const { type } = this
    if (type == 1) {
      this.p_params[params] = is_safe ? await this.getSafeImg(link) : link
    } else {
      this.c_params[params] = is_safe ? await this.getSafeImg(link) : link
    }
  }

  @action
  removeCard = params => () => {
    const { type } = this
    if (type == 1) {
      this.p_params[params] = ''
    } else {
      this.c_params[params] = ''
    }
  }

  @observable type = '2'
  @action
  changeType = value => () => {
    this.type = value
    const {
      flag,
      f_realname,
      f_certify,
      f_certify_front,
      f_certify_back,
      f_company_license,
      f_company_code,
      f_company_name
    } = this
    if (value == 1) {
      this.c_params = {
        c_realname: '',
        c_certify: '',
        c_certify_front: '',
        c_certify_back: '',
        c_company_license: '',
        c_company_code: '',
        c_company_name: ''
      }
      if (value == flag) {
        this.p_params = {
          p_realname: f_realname,
          p_certify: f_certify,
          p_certify_front: f_certify_front,
          p_certify_back: f_certify_back
        }
      }
    } else {
      this.p_params = {
        p_realname: '',
        p_certify: '',
        p_certify_front: '',
        p_certify_back: ''
      }
      if (value == flag) {
        this.c_params = {
          c_realname: f_realname,
          c_certify: f_certify,
          c_certify_front: f_certify_front,
          c_certify_back: f_certify_back,
          c_company_license: f_company_license,
          c_company_code: f_company_code,
          c_company_name: f_company_name
        }
      }
    }
  }

  @action
  changeParams = value => e => {
    const { type } = this
    if (type == '1') {
      this.p_params[value] = e.target.value
    } else {
      this.c_params[value] = e.target.value
    }
  }

  @action
  getParams = () => {
    const { type } = this

    const {
      p_realname,
      p_certify,
      p_certify_front,
      p_certify_back
    } = this.p_params

    const {
      c_realname,
      c_certify,
      c_certify_front,
      c_certify_back,
      c_company_license,
      c_company_code,
      c_company_name
    } = this.c_params

    let msg = this.validation()

    if (msg == 'pass') {
      if (type == '1') {
        return {
          type,
          realname: p_realname,
          certify: p_certify,
          certify_front: p_certify_front,
          certify_back: p_certify_back
        }
      } else {
        return {
          type,
          realname: c_realname,
          certify: c_certify,
          certify_front: c_certify_front,
          certify_back: c_certify_back,
          company_license: c_company_license,
          company_code: c_company_code,
          company_name: c_company_name
        }
      }
    } else {
      return msg
    }
  }

  @action
  validation = () => {
    const { type } = this

    const {
      p_realname,
      p_certify,
      p_certify_front,
      p_certify_back
    } = this.p_params

    const {
      c_realname,
      c_certify,
      c_certify_front,
      c_certify_back,
      c_company_license,
      c_company_code,
      c_company_name
    } = this.c_params

    if (type == '1') {
      if (!p_realname) {
        return '请输入真实姓名!'
      }
      if (!p_certify) {
        return '请输入证件号码!'
      }
      if (!p_certify_front) {
        return '请上传证件正面!'
      }
      if (!p_certify_back) {
        return '请上传证件反面!'
      }
    } else {
      if (!c_realname) {
        return '请输入法人姓名!'
      }
      if (!c_certify) {
        return '请输入法人证件号码!'
      }
      if (!c_certify_front) {
        return '请上传法人证件正面!'
      }
      if (!c_certify_back) {
        return '请上传法人证件反面!'
      }
      if (!c_company_name) {
        return '请输入企业名称!'
      }
      if (!c_company_code) {
        return '请上传统一社会信用代码!'
      }
      // if (c_company_code.length !== 15 && c_company_code.length !== 18) {
      //   return '请填写15或18位标准营业执照编号，由数字和字母组成'
      // }
      if (!c_company_license) {
        return '请上传企业营业执照!'
      }
    }

    return 'pass'
  }

  @action
  submit = (type, indexStore) => () => {
    this.indexStore = indexStore

    // if (type == 1) {
    //   // 无营业执照
    //   this.doCkeckSiyi()
    // } else {
    //   this.doSubmit()
    // }

    this.doSubmit()
  }

  @action
  doSubmit = async () => {
    const { indexStore, infoId } = this
    const { merchantData } = indexStore

    let params = this.getParams()

    if (isObj(params)) {
      let { success } = await siYiApi.creatSiYi({
        ...params,
        is_register_improve: 0,
        ...merchantData,
        id: infoId
      })

      if (success) {
        hashHistory.push('/localMerchant/groupStatus')
      }
    } else {
      message.warning(params)
    }
  }

  @action
  doCkeckSiyi = async () => {
    let params = this.getParams()

    if (isObj(params)) {
      let certifyParams = {
        cert_name: params.realname,
        cert_no: params.certify,
        type: 1
      }

      let {
        data: { url },
        success
      } = await Api.initAuth(certifyParams)
      if (success) {
        const data = await this.getLongtoShort(url)
        if (data && data.errcode == 0) {
          this.shortUrl = data.data.url

          this.checkCertify()
        }

        if (this.shortUrl) {
          this.visible = true
        } else {
          this.doSubmit()
        }
      }
    } else {
      message.warning(params)
    }
  }

  //司仪实名认证调用支付宝芝麻信用的接口，弹出二维码，用支付宝APP扫描
  @observable visible = false
  @observable shortUrl = ''
  @action
  showModal = () => {
    this.visible = !this.visible
    if (this.visible == false) {
      clearInterval(this.timeout)
    }
  }

  //轮询，查看是否已经实名认证
  @observable timeout
  @action
  checkCertify = () => {
    const {
      p_params: { p_realname, p_certify }
    } = this

    const { id } = getMerchantInfo()

    let params = {
      merchant_id: id,
      cert_name: p_realname,
      cert_no: p_certify
    }

    this.timeout = setInterval(async () => {
      let {
        data: { status },
        success
      } = await Api.checkAuth(params)
      if (success && status == 2) {
        this.visible = false
        this.doSubmit()
        clearInterval(this.timeout)
        message.success('认证成功！')
      }
    }, 2000)
  }

  /**
   * 短链转换
   */
  @action
  getLongtoShort = url =>
    http.post(
      `//wfw.hunliji.com/shorturl/long2short?url=${encodeURIComponent(url)}`,
      {
        credentials: 'omit',
        mode: 'cors',
        dataType: 'json',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
        }
      }
    )
}

export default Store
